/** Formats a raw digit string into (XXX) XXX-XXXX */
export function maskPhone(value: string): string {
	const digits = value.replaceAll(/\D/g, '').slice(0, 10);
	if (digits.length <= 3) return digits.length ? `(${digits}` : '';
	if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Formats a raw digit/slash string into MM/DD/YYYY */
export function maskDate(value: string): string {
	const digits = value.replaceAll(/\D/g, '').slice(0, 8);
	if (digits.length <= 2) return digits;
	if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
	return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}
